// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"22014aaf","247":"9b676688","284":"a5bdb4f8","453":"bfa7749b","551":"609c8edd","627":"0ebc7279","834":"69316344","842":"82cf9d2a","867":"c54a45fc","923":"079ec87d","938":"e30a6f8d"}[chunkId] + ".chunk.js";
};